module.exports = __webpack_public_path__ + "img/Belarus.b7ab0b81.svg";